import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Renderer2,
  HostListener,
  Input,
  SimpleChanges,
  computed,
} from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import * as Highcharts from 'highcharts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import html2canvas from 'html2canvas';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, finalize, forkJoin, Observable, of, Subscription, tap } from 'rxjs';
import { MatInputModule } from '@angular/material/input';

import { CommonService } from '../../../services/common.service';
import { LabelService } from '../../../services/label.service';
import { FileConverterService } from '../../../services/file-converter.service';
import { SharedDataService } from '../../../services/shared-data.service';
import * as Constants from '../../../shared/constant';
import * as Types from '../../../shared/types';
import { Labels, LabelTypes } from '../../../shared/label.types';
import { FilterService } from '../../../services/filter.service';
import { ApiCacheService } from '../../../services/api-cache.service';
import { ApiLoadingService } from '../../../services/api-loading.service';
import { transformTestToFilters } from '../../../shared/appUtil';
import { NotificationService } from '../../../services/notification.service';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { PredefinedChartsContainerComponent } from '../../../components/predefined-charts/predefined-charts-container.component';

@Component({
  selector: 'app-data-explorer',
  standalone: true,
  imports: [
    MatTooltipModule,
    CommonModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatTabsModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,
    HighchartsChartModule,
    NgMultiSelectDropDownModule,
    FormsModule,
    HttpClientModule,
    MatSlideToggleModule,
    ToastrModule,
    LoadingComponent,
    PredefinedChartsContainerComponent,
  ],
  providers: [CommonService, LabelService, FileConverterService],
  templateUrl: './data-explorer.component.html',
  styleUrl: './data-explorer.component.scss',
})
export class DataExplorerComponent {
  @Input() chatBoxVisibilityFlag: boolean | undefined;

  loaderFlag: boolean = false;
  overviewSectionTitle: string | undefined = 'Conversation Overview';
  totalConversations: number = 1400;
  primaryTopics: number = 13;
  reason: number = 22;
  rootCause: number = 36;
  issueResolutionRate: number = 79.1;
  averageDuration: string = '02:33';
  labels: Labels = {} as Labels;
  sentiments = ['Positive', 'Neutral', 'Negative'];
  filteredSentiments = [...this.sentiments];
  selectedSentiments: string[] = [];
  allSelected = false;
  percentageChartDates: Array<string[]> = [];
  myFilteredData: { [key: string]: string[] } = {};
  tableViewFlag: boolean = false;
  dropdownSettings: IDropdownSettings = Constants.DropdownSettings;
  sentimentCounts: Types.SentimentCountsData[] = [];
  Highcharts: typeof Highcharts = Highcharts;
  filterListPrimaryTopics: string[] = [];
  filterListResolution: string[] = [];
  filterListCaller: string[] = [];
  filterSentiment: string[] = [];
  filterCustomerSentimentAtStart: string[] = [];
  filterCustomerSentimentAtEnd: string[] = [];
  filterJourney: string[] = [];
  filterCustomerIntent: string[] = [];
  filterRootCause: string[] = [];
  filterAgent_Username: string[] = [];
  filterAttributes_authenticationStatus: string[] = [];
  filterAttributes_tier: string[] = [];
  filterInitiationMethod: string[] = [];
  filterQueue_Name: string[] = [];
  filterCustomerPainPoint: string[] = [];
  filterAgent_AgentInteractionDuration: string[] = [];
  openFilterOptions = false;
  hoveredGroupIndex = -1;
  filterGroups: Types.FilterGroup[] = [];
  initialFilterState: Types.FilterGroup[] = [];
  filterChanges: boolean = false;
  uniqueDatesArray: string[] = [];
  durations: Types.DateFilterOption[] = Constants.Durations;
  durationDropdownSettings: IDropdownSettings = Constants.DurationDropdownSettings;
  fromDate: string = '';
  toDate: string = '';
  lastValidSelection: Types.DateFilterOption = { d_id: 4, name: 'Last 7 Days' };
  isCustomDate: boolean = false;
  customFromDate: string = '';
  customToDate: string = '';
  tableViewBody: Types.TableViewBody = {} as Types.TableViewBody;
  /** Stable payload for predefined charts; set when date range/filters change so APIs are triggered. */
  predefinedChartsPayload: { start_date: string; end_date: string; filters: Types.FilterRequest[]; timeZone: string } | null = null;
  activeGroupIndex: number | null = null;
  chipActiveGroupIndex: number | null = null;
  searchQuery: string[] = [];
  myFilterListForAPI: Types.FilterRequest[] = [];
  activeTab: string = 'tabular'; // Default active tab
  startAPIDate: string | undefined;
  endAPIDate: string | undefined;
  isSelectButtonEnabled: boolean[] = [];
  topics: Array<{ label: string; key: string }> = [];
  apiLoading = true;
  protected _tableViewFlag = computed<boolean>(() => this.sharedDataService.tableViewFlagStatus());
  private subscription: Subscription | undefined;
  private filterRefreshSubscription: Subscription | undefined;
  private timezoneChangeSubscription: Subscription | undefined;
  private apiLoadingSubscription: Subscription | undefined;
  private labelDataSubscription: Subscription | undefined;
  private loaderFlagSubscription: Subscription | undefined;
  private isViewSwitching = false;
  private hasLoadedData = false;
  private isLoadingData = false;

  showTab(tab: string): void {
    this.activeTab = tab;
  }

  setViewSwitching(switching: boolean): void {
    this.isViewSwitching = switching;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    public sharedDataService: SharedDataService,
    public commonService: CommonService,
    public labelService: LabelService,
    private renderer: Renderer2,
    private el: ElementRef,
    private toastr: ToastrService,
    private filterService: FilterService,
    private notificationService: NotificationService,
    private apiCacheService: ApiCacheService,
    private apiLoadingService: ApiLoadingService
  ) {}

  ngOnInit(): void {
    this.commonService.setLoaderFlag(true);

    // Reset the flags when component initializes
    this.hasLoadedData = false;
    this.isLoadingData = false;

    this.apiLoadingSubscription = this.sharedDataService.apiLoading().subscribe((data: boolean) => {
      this.apiLoading = data;
    });

    setTimeout(() => {
      this.commonService.setLoaderFlag(false);
      this.sharedDataService.setApiLoading(false);
      this.cdr.markForCheck();
    }, 800);

    this.labelDataSubscription = this.labelService.getLabelData().subscribe((data: LabelTypes) => {
      this.labels = data?.labels ?? {};
    });

    this.loaderFlagSubscription = this.commonService.getLoaderFlag().subscribe((flag) => {
      this.loaderFlag = flag;
    });

    this.subscription = this.sharedDataService.getDateRange().subscribe((date) => {
      this.startAPIDate = date.startAPIDate;
      this.endAPIDate = date.endAPIDate;
      if (date.startAPIDate && date.endAPIDate) {
        this.predefinedChartsPayload = this.getPredefinedChartsPayload();
      } else {
        this.predefinedChartsPayload = null;
      }
      if (date.startAPIDate && date.dateSelected) {
        this.predefinedChartsPayload = this.getPredefinedChartsPayload();
        this.hasLoadedData = true;
        this.cdr.markForCheck();
      }
    });

    this.filterRefreshSubscription = this.filterService.getRefreshDataStatus().subscribe((status) => {
      // Only trigger API calls if we're in chart view (not table view) and have valid date range
      if (status && !this._tableViewFlag() && this.startAPIDate && this.endAPIDate) {

        // Add a small delay to prevent race conditions with other components
        setTimeout(() => {
          // Double-check we're still in chart view after the delay
          if (!this._tableViewFlag() && this.startAPIDate && this.endAPIDate) {
            this.predefinedChartsPayload = this.getPredefinedChartsPayload();
            this.hasLoadedData = true;
            this.cdr.markForCheck();
          }
        }, 50); // Small delay to prevent race conditions
      }
    });

    // Listen for timezone changes and trigger API calls
    this.timezoneChangeSubscription = this.sharedDataService.getTimezoneChange().pipe(
      debounceTime(300) // Debounce to prevent rapid successive calls
    ).subscribe((timezone) => {
      // Only trigger API calls if we have valid date range
      if (this.startAPIDate && this.endAPIDate) {

        // Ensure the timezone value is updated in the shared service
        this.sharedDataService.selectedTimezoneValue = timezone;

        this.predefinedChartsPayload = this.getPredefinedChartsPayload();
        this.hasLoadedData = true;
        this.cdr.markForCheck();
      }
    });

    this.dropdownSettings = Constants.DropdownSettings;

    this.makeFilterBodyClearSet();

    this.initializeTempSelections();
    this.isSelectButtonEnabled = this.filterGroups.map(() => false);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.filterRefreshSubscription) {
      this.filterRefreshSubscription.unsubscribe();
    }
    if (this.timezoneChangeSubscription) {
      this.timezoneChangeSubscription.unsubscribe();
    }
    if (this.apiLoadingSubscription) {
      this.apiLoadingSubscription.unsubscribe();
    }
    if (this.labelDataSubscription) {
      this.labelDataSubscription.unsubscribe();
    }
    if (this.loaderFlagSubscription) {
      this.loaderFlagSubscription.unsubscribe();
    }
  }

  //Data filter functionality start
  initializeTempSelections(): void {
    this.filterGroups.forEach((group: Types.FilterGroup) => {
      group.filters.tempAllSelected = group.filters.allSelected;
      group.filters?.options?.forEach((option: Types.FilterOption) => {
        option.tempIsSelected = option.isSelected;
      });
      this.isSelectButtonEnabled = this.filterGroups.map(() => false);
    });
  }

  toggleFilterOptions(event: MouseEvent): void {
    this.openFilterOptions = !this.openFilterOptions;
    this.activeGroupIndex = null;
    this.chipActiveGroupIndex = null;
    this.activeGroupIndex1 = null;
    event?.stopPropagation();
  }

  toggleGroupOptions(index: number, event: MouseEvent): void {
    this.initializeTempSelections();
    this.activeGroupIndex = this.activeGroupIndex === index ? null : index;
    this.chipActiveGroupIndex = null;
    event?.stopPropagation();
  }

  activeGroupIndex1: number | null = null;
  toggleChipGroupOptions(index: number, event: MouseEvent): void {
    if (this.chipActiveGroupIndex === index) {
      this.revertTempSelections(index);
    }
    this.chipActiveGroupIndex = this.chipActiveGroupIndex === index ? null : index;
    this.activeGroupIndex = null;
    this.activeGroupIndex1 = this.activeGroupIndex1 === index ? null : index;
    this.openFilterOptions = false;
    event?.stopPropagation();
  }

  revertTempSelections(index: number): void {
    if (index >= 0 && index < this.filterGroups.length) {
      const filterGroup = this.filterGroups[index];
      filterGroup.filters.tempAllSelected = filterGroup.filters.allSelected;
      filterGroup.filters.options.forEach((option: Types.FilterOption) => {
        option.tempIsSelected = option.isSelected;
      });
    }
  }

  applyFilterChanges(dropdownIndex: number): void {
    if (dropdownIndex >= 0 && dropdownIndex < this.filterGroups.length) {
      const filterGroup = this.filterGroups[dropdownIndex];
      filterGroup.filters.allSelected = filterGroup.filters.tempAllSelected ?? false;
      filterGroup.filters.options.forEach((option: Types.FilterOption) => {
        option.isSelected = option.tempIsSelected ?? false;
      });

      this.populateFilteredData();
      this.checkFilterChanges();
      this.chipActiveGroupIndex = null;
    }
    this.activeGroupIndex1 = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.el.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.openFilterOptions = false;
      this.activeGroupIndex = null;
      this.chipActiveGroupIndex = null;
      this.hoveredGroupIndex = -1;
      this.searchQuery = [];
    }
  }

  stopPropagation(event: MouseEvent) {
    event?.stopPropagation();
  }

  searchFilter(options: Types.FilterOption[] = [], query: string): Types.FilterOption[] {
    if (!query || query.trim() === '') {
      return options;
    }
    const filteredOptions = options.filter((option) => option.name.toLowerCase().includes(query.toLowerCase()));
    return filteredOptions;
  }

  getSelectedCount(options: Types.FilterOption[]): number {
    return options.filter((option) => option.isSelected).length;
  }

  getFirstSelectedOption(options: Types.FilterOption[]): string {
    const selectedOption = options.find((option) => option.isSelected);
    return selectedOption ? selectedOption.name : '';
  }

  selectAll(event: any, dropdownIndex: number): void {
    if (dropdownIndex >= 0 && dropdownIndex < this.filterGroups.length) {
      this.filterGroups[dropdownIndex].filters.allSelected = event.checked;
      this.filterGroups[dropdownIndex].filters.options.forEach((option: Types.FilterOption) => {
        option.isSelected = event.checked;
      });
      this.populateFilteredData();
    }
    this.checkFilterChanges();
    event?.stopPropagation();
  }

  shouldShowGroup(group: any): boolean {
    return group.filters.allSelected || this.getSelectedCount(group.filters.options) > 0;
  }

  toggleSelection(option: any, event: any, dropdownIndex: number): void {
    option.isSelected = event.checked;
    this.updateFilteredSelection(dropdownIndex);
    this.checkFilterChanges();
  }

  updateFilteredSelection(dropdownIndex: number): void {
    this.filterGroups[dropdownIndex].filters.allSelected = true;
    this.filterGroups[dropdownIndex].filters.options.forEach((option: any) => {
      this.filterGroups[dropdownIndex].filters.allSelected =
        option.isSelected && this.filterGroups[dropdownIndex].filters.allSelected;
    });
    this.checkFilterChanges();
  }

  removeOption(dropdownIndex: any, optionIndex: any): void {
    if (dropdownIndex >= 0 && dropdownIndex < this.filterGroups.length) {
      this.filterGroups[dropdownIndex].filters.options[optionIndex].isSelected = false;
      this.filterGroups[dropdownIndex].filters.allSelected = false;
      this.populateFilteredData();
    }
    this.checkFilterChanges();
  }

  removeAllSelected(dropdownIndex: any): void {
    if (dropdownIndex >= 0 && dropdownIndex < this.filterGroups.length) {
      this.filterGroups[dropdownIndex].filters.allSelected = false;
      this.filterGroups[dropdownIndex].filters.options.forEach((option: any) => {
        option.isSelected = false;
      });
      this.populateFilteredData();
      this.checkFilterChanges();
    }
  }

  populateFilteredData(): Types.FilterRequest[] {
    const filterDataArray = this.filterService.getFilterConditionDataValue();
    const { data, error } = transformTestToFilters(filterDataArray);
    const filterApplied = this.filterService.getFilterAppliedStatusValue();

    const filteredData: Types.FilterRequest[] = [...data];
    if (error && filterApplied) {
      // this.notificationService.error('Error in filters', 'Error in filters');
    }
    return filteredData;
  }

  /** Payload for predefined charts: same date range, filters and timezone as chart view APIs. */
  getPredefinedChartsPayload(): { start_date: string; end_date: string; filters: Types.FilterRequest[]; timeZone: string } | null {
    if (!this.startAPIDate || !this.endAPIDate) return null;
    return {
      start_date: this.startAPIDate,
      end_date: this.endAPIDate,
      filters: this.populateFilteredData(),
      timeZone: this.sharedDataService.selectedTimezoneValue || 'UTC',
    };
  }

  @HostListener('document:click', ['$event'])
  onContentClick(event: MouseEvent): void {
    this.openFilterOptions = false;
    this.activeGroupIndex = null;
    this.activeGroupIndex1 = null;
    this.chipActiveGroupIndex = null;
  }

  transformFilterKeyData(originalData: any): any {
    const newData: any = {};
    for (const key in originalData) {
      if (originalData.hasOwnProperty(key)) {
        const newKey = key.replace(/\s/g, '');
        newData[newKey] = originalData[key];
      }
    }
    return newData;
  }

  applyFilters(): void {
    const data = this.populateFilteredData();
    this.myFilterListForAPI = data;
    this.commonService.historyPageNumber = 1;

    this.predefinedChartsPayload = this.getPredefinedChartsPayload();
    this.cdr.markForCheck();
    this.storeInitialFilterState();
    this.checkFilterChanges();
  }

  checkFilterChanges() {
    this.filterChanges = !this.filterGroups.every((group: { filters: { options: any[] } }, groupIndex: number) => {
      return group?.filters?.options?.every((option, optionIndex) => {
        return option.isSelected === this.initialFilterState[groupIndex]?.filters?.options[optionIndex].isSelected;
      });
    });
  }

  selectAllTemp(event: any, dropdownIndex: number): void {
    if (dropdownIndex >= 0 && dropdownIndex < this.filterGroups.length) {
      this.filterGroups[dropdownIndex].filters.tempAllSelected = event.checked;
      this.filterGroups[dropdownIndex].filters.options.forEach((option: any) => {
        option.tempIsSelected = event.checked;
      });
      this.checkTempSelectionChanges(dropdownIndex);
    }
    event?.stopPropagation();
  }

  toggleTempSelection(option: any, event: any, dropdownIndex: number): void {
    option.tempIsSelected = event.checked;
    this.updateTempFilteredSelection(dropdownIndex);
    this.checkTempSelectionChanges(dropdownIndex);
  }

  checkTempSelectionChanges(dropdownIndex: number): void {
    if (dropdownIndex >= 0 && dropdownIndex < this.filterGroups.length) {
      const filterGroup = this.filterGroups[dropdownIndex];
      this.isSelectButtonEnabled[dropdownIndex] = filterGroup.filters.options.some(
        (option: any) => option.tempIsSelected !== option.isSelected
      );
    }
  }

  updateTempFilteredSelection(dropdownIndex: number): void {
    this.filterGroups[dropdownIndex].filters.tempAllSelected = true;
    this.filterGroups[dropdownIndex].filters.options.forEach((option: any) => {
      this.filterGroups[dropdownIndex].filters.tempAllSelected =
        option.tempIsSelected && this.filterGroups[dropdownIndex].filters.tempAllSelected;
    });
  }

  isContentVisible: boolean = true;
  isImageRotated: boolean = false;

  filterBoxAction(event: Event): void {
    this.isContentVisible = !this.isContentVisible;
    this.isImageRotated = !this.isImageRotated;
  }

  showChartView(): void {
    if (this.tableViewFlag) {
      this.tableViewFlag = false;
    }
  }

  showDataView(): void {
    if (!this.tableViewFlag) {
      this.tableViewFlag = true;
    }
  }

  makeFilterBodyClear() {
    this.myFilterListForAPI = [];
    this.loadFilterList();
    this.initializeFilter();
    if (this.startAPIDate && this.endAPIDate) {
      this.predefinedChartsPayload = this.getPredefinedChartsPayload();
      this.cdr.markForCheck();
    }
  }

  makeFilterBodyClearSet() {
    this.myFilterListForAPI = [];
    this.loadFilterList();
    this.initializeFilter();
  }

  //Data filter functionality end
  addQuotesToKeys(obj: any): any {
    const quotedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        quotedObj[`"${key}"`] = obj[key];
      }
    }
    return quotedObj;
  }

  closeDropdown(dropdown: any) {
    setTimeout(() => {
      dropdown.closeDropdown();
    });
  }

  categorizeDateTime(array: any) {
    const timeRegex = /^(1[0-2]|[1-9]) (AM|PM)$/;

    if (array.every((item: any) => typeof item === 'string' && timeRegex.test(item))) {
      return { dates: undefined, times: array };
    }

    return { dates: array, times: undefined };
  }

  filterBody: any;
  fetchDataFiltersAPIData(): void {}

  initializeFilter() {}

  storeInitialFilterState() {
    this.initialFilterState = JSON.parse(JSON.stringify(this.filterGroups));
  }

  convertToFilterOptionArray(data: string[]): Types.FilterOption[] {
    return data
      ?.filter((item) => item && typeof item === 'string' && item?.trim() !== '') // Remove empty items
      ?.map((item, index) => ({
        filterId: (index + 1).toString(),
        name: item,
        isSelected: true,
      }));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chatBoxVisibilityFlag']) {
    }
  }

  customizedDates: string[] = [];

  transformDates(dates: (string | null)[][]): string[] {
    if (!dates || !Array.isArray(dates)) {
      return [];
    }

    return dates.map((range) => {
      if (!Array.isArray(range) || range.length < 1 || range.length > 2) {
        return '';
      }

      const [start, end] = range;

      // Create date objects in UTC by appending 'Z' to the date strings
      const startDate = start ? new Date(start + 'T00:00:00Z') : null;
      const endDate = end ? new Date(end + 'T00:00:00Z') : null;

      const options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      };

      const formattedStart = startDate ? new Intl.DateTimeFormat('en-US', options).format(startDate) : '';

      if (!endDate || !end) {
        return formattedStart;
      }

      const formattedEnd = endDate ? new Intl.DateTimeFormat('en-US', options).format(endDate) : '';

      return `${formattedStart} - ${formattedEnd}`;
    });
  }

  loadFetchFunctions() {
    if (this._tableViewFlag() || !this.startAPIDate || !this.endAPIDate) {
      return;
    }
    this.tableViewBody = {
      start_date: this.startAPIDate,
      end_date: this.endAPIDate,
      filters: this.populateFilteredData(),
      timeZone: this.sharedDataService.selectedTimezoneValue,
    };
    this.predefinedChartsPayload = this.getPredefinedChartsPayload();
    this.cdr.markForCheck();
  }

  fetchTableValueAPIData(pageSize: number, pageNumber: number): void {
    this.tableViewBody = {
      start_date: this.startAPIDate,
      end_date: this.endAPIDate,
      filters: this.populateFilteredData(),
    };

    this.commonService.fetchTableValues(this.tableViewBody, pageSize, pageNumber).subscribe({
      next: (data) => {
        const transformedData = this.transformData(data.conversations);
        // this.commonService.rowValue = data.total_count;
        this.commonService.rowValue = this.sharedDataService.totalConversations;

        this.sharedDataService.setApiTotalRow(this.commonService.rowValue);

        this.commonService.totalSize = this.commonService.rowValue;
        this.commonService.visiblePageBlock = Math.ceil(
          this.commonService.totalSize / parseInt(this.commonService.perPageItem)
        );

        this.commonService.dataSource.data = transformedData;
        this.commonService.filteredDataSource.data = transformedData;

        this.commonService.filteredDataSource.data = [...this.commonService.dataSource.data];
      },
      error: (error) => {
        console.error('API Error:', error);
      },
    });
  }

  transformData(conversations: any[]): any[] {
    return conversations.map((conversation) => {
      const insights = conversation.Insights;
      const contactAttributes = conversation.ContactAttributes;
      return {
        ContactId: conversation.ContactId,
        Date: conversation.ContactTimestamp,
        Intent: insights.Intent,
        PrimaryTopic: insights.PrimaryTopic,
        Summary: insights.Summary,
        CallerType: insights.CallerType,
        JourneyMoment: insights.JourneyMoment,
        CustomerSentimentAtStart: insights.CustomerSentimentAtStart,
        CustomerSentimentAtEnd: insights.CustomerSentimentAtEnd,
        CallResolution: insights.CallResolution,
        Topics: insights.Topics,
        RootCause: insights.RootCause,
        Agent_AgentInteractionDuration: contactAttributes.Agent_AgentInteractionDuration,
        Agent_ConnectedToAgentTimestamp: contactAttributes.Agent_ConnectedToAgentTimestamp,
        Agent_Username: contactAttributes.Agent_Username,
        Attributes_authenticationStatus: contactAttributes.Attributes_authenticationStatus,
        Attributes_tier: contactAttributes.Attributes_tier,
        InitiationMethod: contactAttributes.InitiationMethod,
        Queue_Name: contactAttributes.Queue_Name,
        CustomerPainPoint: insights?.CustomerPainPoint,
      };
    });
  }

  loadFilterList() {
    this.fetchDataFiltersAPIData();
  }
}
